// extracted by mini-css-extract-plugin
module.exports = {"Comments":"Comments_Comments__1N2di","Comments-Label":"Comments_Comments-Label__1qJVW","Comments-CommentInfo":"Comments_Comments-CommentInfo__1IQ9z"};